<template>
  <div>
    <Row>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.databaseTypes' )" prop="databaseType">
          <Select v-model="resourceApplicationForm.databaseType" filterable
                  @on-change="changeDatabaseType(resourceApplicationForm.databaseType)">
            <Option :value="item.id" v-for="(item,index) in databaseTypeList" v-bind:key="item.id">{{item.name}}
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <!-- 当数据库类型为"Azure MySQL 服务器"时 显示 -->
    <div v-if="resourceApplicationForm.databaseType==5||resourceApplicationForm.databaseType==6">
      <Row>
        <Col span="11">
          <FormItem :label="$t( 'resourceLifecycle.serverName' )" prop="name">
            <Input v-model="resourceApplicationForm.name" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
          </FormItem>
        </Col>
      </Row>

      <div v-if="resourceApplicationForm.databaseType==5">
        <Row>
          <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.versions' )" prop="mySqulVersion">
              <Select v-model="resourceApplicationForm.mySqulVersion" filterable>
                <Option :value="item.mySqulVersion" v-for="item in mySqulVersionList" v-bind:key="item.mySqulVersion">
                  {{item.mySqulVersion}}
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </div>

      <div v-if="resourceApplicationForm.databaseType==6">
        <Row>
          <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.versions' )" prop="mariaDBVersion">
              <Select v-model="resourceApplicationForm.mariaDBVersion" filterable>
                <Option :value="item.mariaDBVersion" v-for="item in mariaDBVersionList"
                        v-bind:key="item.mariaDBVersion">
                  {{item.mariaDBVersion}}
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </div>

      <Row>
        <Col span="11">
          <FormItem :label="$t( 'resourceLifecycle.serverTypes' )" prop="serverType">
            <Select v-model="resourceApplicationForm.serverType" filterable
                    @on-change="changeServerType(resourceApplicationForm.serverType)">
              <Option :value="item.label" v-for="(item,index) in serverTypeList" v-bind:key="item.label">{{item.name}}
              </Option>
            </Select>
          </FormItem>
        </Col>
      </Row>

      <!-- 服务器类型为"基本" -->
      <div v-if="resourceApplicationForm.serverType=='Basic'">
        <Row>
          <Col span="11">
            <FormItem label="vCore" prop="skuCapacity">
              <InputNumber :min="1" :max="2" v-model="resourceApplicationForm.skuCapacity"
                           @on-change="queryAzureDatabasePrice"
                           :active-change="false"></InputNumber>
            </FormItem>
          </Col>
          <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.storing' )" prop="storage">
              <InputNumber :min="5" :max="1024" v-model="resourceApplicationForm.storage"
                           @on-change="queryAzureDatabasePrice"
                           :active-change="false"></InputNumber>
              GB
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.storageAutomatedGrowth' )" prop="storageAutoGrow">
              <RadioGroup v-model="resourceApplicationForm.storageAutoGrow">
                <Radio v-for="list in storageAutoGrowList" :label="list.storageAutoGrow" :key="list.value">
                  {{list.label}}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.backuphold' )" prop="backupRetentionDays">
              <InputNumber :min="7" :max="35" v-model="resourceApplicationForm.backupRetentionDays"
                           :active-change="false"></InputNumber>
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.backupredundancy' )" prop="basicGeoRedundantBackup">
              <RadioGroup v-model="resourceApplicationForm.basicGeoRedundantBackup">
                <Radio v-for="list in basicGeoRedundantBackupList" :label="list.basicGeoRedundantBackup"
                       :key="list.value">{{list.label}}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
      </div>
      <!-- 服务器类型为"常规用途" -->
      <div v-if="resourceApplicationForm.serverType=='GeneralPurpose'">
        <Row>
          <Col span="11">
            <FormItem label="vCore" prop="skuCapacity">
              <InputNumber :min="2" :max="64" v-model="resourceApplicationForm.skuCapacity"
                           @on-change="queryAzureDatabasePrice"
                           :active-change="false"></InputNumber>
            </FormItem>
          </Col>
          <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.storing' )" prop="storage">
              <InputNumber :min="5" :max="4096" v-model="resourceApplicationForm.storage"
                           @on-change="queryAzureDatabasePrice"
                           :active-change="false"></InputNumber>
              GB
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.storageAutomatedGrowth' )" prop="storageAutoGrow">
              <RadioGroup v-model="resourceApplicationForm.storageAutoGrow">
                <Radio v-for="list in storageAutoGrowList" :label="list.storageAutoGrow" :key="list.value">
                  {{list.label}}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.backuphold' )" prop="backupRetentionDays">
              <InputNumber :min="7" :max="35" v-model="resourceApplicationForm.backupRetentionDays"
                           :active-change="false"></InputNumber>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.backupredundancy' )" prop="geoRedundantBackup">
              <RadioGroup v-model="resourceApplicationForm.geoRedundantBackup">
                <Radio v-for="list in geoRedundantBackupList" :label="list.geoRedundantBackup" :key="list.value">
                  {{list.label}}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
      </div>
      <!-- 服务器类型为"内存优化" -->
      <div v-if="resourceApplicationForm.serverType=='MemoryOptimized'">
        <Row>
          <Col span="11">
            <FormItem label="vCore" prop="skuCapacity">
              <InputNumber :min="2" :max="32" v-model="resourceApplicationForm.skuCapacity"
                           @on-change="queryAzureDatabasePrice"
                           :active-change="false"></InputNumber>
            </FormItem>
          </Col>
          <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.storing' )" prop="storage">
              <InputNumber :min="5" :max="4096" v-model="resourceApplicationForm.storage"
                           @on-change="queryAzureDatabasePrice"
                           :active-change="false"></InputNumber>
              GB
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.storageAutomatedGrowth' )" prop="storageAutoGrow">
              <RadioGroup v-model="resourceApplicationForm.storageAutoGrow">
                <Radio v-for="list in storageAutoGrowList" :label="list.storageAutoGrow" :key="list.value">
                  {{list.label}}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.backuphold' )" prop="backupRetentionDays">
              <InputNumber :min="7" :max="35" v-model="resourceApplicationForm.backupRetentionDays"
                           :active-change="false"></InputNumber>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.backupredundancy' )" prop="geoRedundantBackup">
              <RadioGroup v-model="resourceApplicationForm.geoRedundantBackup">
                <Radio v-for="list in geoRedundantBackupList" :label="list.geoRedundantBackup" :key="list.value">
                  {{list.label}}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
      </div>

      <Row>
        <Col span="11">
          <FormItem :label="$t( 'resourceLifecycle.username' )" prop="userName">
            <Input v-model="resourceApplicationForm.userName" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
          </FormItem>
        </Col>
        <Col span="11">
          <FormItem :label="$t( 'resourceLifecycle.passwords' )" prop="password">
            <Input v-model="resourceApplicationForm.password" type="password" :placeholder="$t( 'resourceLifecycle.pleaseenter')"></Input>
          </FormItem>
        </Col>
      </Row>
    </div>


    <!-- 当数据库类型为"Azure Redis 服务器"时 显示 -->
            <div v-if="resourceApplicationForm.databaseType==7">
              <Row>
                <Col span="11">
                  <FormItem :label="$t( 'resourceLifecycle.dNSName' )" prop="dnsName">
                    <Input v-model="resourceApplicationForm.dnsName" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
                  </FormItem>
                </Col>
              </Row>

              <Row>
                <Col span="11">
                  <FormItem :label="$t( 'resourceLifecycle.pricingLayer' )" prop="pricingLayer">
                    <Select v-model="resourceApplicationForm.pricingLayer" filterable @on-change="queryAzureDatabasePrice">
                      <Option :value="item.name" v-for="(item,index) in pricingLayerList" v-bind:key="item.name">
                        {{item.pricingTier}}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>

              <Row>
                <Col span="11">
                  <FormItem :label="$t( 'resourceLifecycle.whethertoenableunencryptedSSL' )" prop="enableNonSslPort">
                    <RadioGroup v-model="resourceApplicationForm.enableNonSslPort">
                      <Radio v-for="list in enableNonSslPortList" :label="list.enableNonSslPort" :key="list.value">
                        {{list.label}}
                      </Radio>
                    </RadioGroup>
                  </FormItem>
                </Col>
              </Row>
            </div>
    </div>
</template>

<script>
  import {setCookie, getCookie, delCookie} from '../../../../../utils/cookieUtil.js'

  export default {
    name: 'AmazonVirtualMachine',
    props: ['azureResourceApplicationBasicInfoForm', 'cost'],
    components: {},
    data() {
      return {
        databaseTypeList: [{
          id: 5,
          name: this.$t( 'resourceLifecycle.azureMySQLServer' )
        }, {
          id: 6,
          name: this.$t( 'resourceLifecycle.azureMariaDBServer' )
        }, {
          id: 7,
          name: this.$t( 'resourceLifecycle.azureRedisServer' )
        }],
        serverTypeList: [{
          label: 'Basic',
          name: this.$t( 'resourceLifecycle.base' )
        }, {
          label: 'GeneralPurpose',
          name: this.$t( 'resourceLifecycle.generalPurpose' )
        }, {
          label: 'MemoryOptimized',
          name: this.$t( 'resourceLifecycle.memoryOptimization' )
        }],
        mySqulVersionList: [{
          mySqulVersion: '5.6'
        }, {
          mySqulVersion: '5.7'
        }, {
          mySqulVersion: '8.0'
        }],
        mariaDBVersionList: [{
          mariaDBVersion: '10.2'
        }, {
          mariaDBVersion: '10.3'
        }],
        pricingLayerList: [],
        enableNonSslPortList: [{
          label: this.$t( 'resourceLifecycle.enabling' ),
          value: 'enable',
          enableNonSslPort: 0
        }, {
          label: this.$t( 'resourceLifecycle.donotenable' ),
          value: 'disabled',
          enableNonSslPort: 1
        }],
        storageAutoGrowList: [{
          label: this.$t( 'resourceLifecycle.enabling' ),
          value: 'Enabled',
          storageAutoGrow: 0
        }, {
          label: this.$t( 'resourceLifecycle.disabling' ),
          value: 'Disabled',
          storageAutoGrow: 1
        }],
        geoRedundantBackupList: [{
          label: this.$t( 'resourceLifecycle.localredundancy' ),
          value: 'Disabled',
          geoRedundantBackup: 1
        }, {
          label: this.$t( 'resourceLifecycle.districtredundancy' ),
          value: 'Enabled',
          geoRedundantBackup: 0
        }],
        basicGeoRedundantBackupList: [{
          label: this.$t( 'resourceLifecycle.localredundancy' ),
          value: 'Disabled',
          basicGeoRedundantBackup: 1
        }],
        resourceApplicationForm: {
          name: '',
          mySqulVersion: '',
          databaseType: 5,
          serverType: 'Basic',
          userName: '',
          password: '',
          dnsName: '',
          pricingLayer: '',
          enableNonSslPort: 0,
          skuCapacity: 1,
          storage: 5,
          backupRetentionDays: 7,
          storageAutoGrow: 0,
          mariaDBVersion: '',
          geoRedundantBackup: 1,
          basicGeoRedundantBackup: 1,
          cost: 0
        },
        ruleValidate: {
          name: [
            {required: true, message: this.$t( 'resourceLifecycle.namecannotbeempty' ), trigger: 'blur'}
          ],
          mySqulVersion: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselecttheversion' ), trigger: 'change'}
          ],
          mariaDBVersion: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselecttheversion' ), trigger: 'change'}
          ],
          serverType: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselecttheservertype' ), trigger: 'change'}
          ],
          databaseType: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectthedatabasetype' ), trigger: 'change', type: 'number'}
          ],
          userName: [
            {required: true, message: this.$t( 'resourceLifecycle.usernamecannotbeempty' ), trigger: 'blur'}
          ],
          password: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseenterapassword' ), trigger: 'blur'}
          ],
          dnsName: [
            {required: true, message: this.$t( 'resourceLifecycle.dNSnamecannotbeempty' ), trigger: 'blur'}
          ],
          pricingLayer: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectPricingLevel' ), trigger: 'change'}
          ],
          enableNonSslPort: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectwhethertoenablenonsslRedisserverport' ), trigger: 'change', type: 'number'}
          ],
          skuCapacity: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseentervCore' ), trigger: 'blur', type: 'number'}
          ],
          storage: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseenterstorage' ), trigger: 'blur', type: 'number'}
          ],
          backupRetentionDays: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseenterthebackuphold' ), trigger: 'blur', type: 'number'}
          ],
          storageAutoGrow: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectthestorageforautogrowth' ), trigger: 'change', type: 'number'}
          ],
          geoRedundantBackup: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectBackupRedundancy' ), trigger: 'change', type: 'number'}
          ]
        }
      }
    },
    mounted: function () {
      this.queryAzureDatabasePrice();
    },
    methods: {
      //查询价格
      queryAzureDatabasePrice: function () {
        var submitLifecycleResourceApplicationDTO = {
          "duration": this.azureResourceApplicationBasicInfoForm.periodOfUse,
          "region": this.azureResourceApplicationBasicInfoForm.region
        }
        if (this.resourceApplicationForm.databaseType == 5) {
          // Azure 托管数据库&&数据库类型为"Azure MySQL 服务器"
          submitLifecycleResourceApplicationDTO.lifecycleResourceAzureMySQLDTO = {
            "accountId": this.azureResourceApplicationBasicInfoForm.accountId,
            "location": this.azureResourceApplicationBasicInfoForm.region,
            "resourceGroup": this.azureResourceApplicationBasicInfoForm.resourceGroup,

            "dbName": this.resourceApplicationForm.name,
            "storage": this.resourceApplicationForm.storage,
            "administratorLogin": this.resourceApplicationForm.userName,
            "administratorLoginPassword": this.resourceApplicationForm.password,
            "serverVersion": this.resourceApplicationForm.mySqulVersion,
            "skuTier": this.resourceApplicationForm.serverType,
            "skuCapacity": this.resourceApplicationForm.skuCapacity,
            "backupRetentionDays": this.resourceApplicationForm.backupRetentionDays,
            "geoRedundantBackup": this.resourceApplicationForm.geoRedundantBackup,
            "storageAutoGrow": this.resourceApplicationForm.storageAutoGrow
          }
        } else if (this.resourceApplicationForm.databaseType == 6) {
          // Azure 托管数据库&&数据库类型为"Azure MariaDB 服务器"
          submitLifecycleResourceApplicationDTO.lifecycleResourceAzureMariaDBDTO = {
            "accountId": this.azureResourceApplicationBasicInfoForm.accountId,
            "location": this.azureResourceApplicationBasicInfoForm.region,
            "resourceGroup": this.azureResourceApplicationBasicInfoForm.resourceGroup,

            "dbName": this.resourceApplicationForm.name,
            "storage": this.resourceApplicationForm.storage,
            "administratorLogin": this.resourceApplicationForm.userName,
            "administratorLoginPassword": this.resourceApplicationForm.password,
            "serverVersion": this.resourceApplicationForm.mariaDBVersion,
            "skuTier": this.resourceApplicationForm.serverType,
            "skuCapacity": this.resourceApplicationForm.skuCapacity,
            "backupRetentionDays": this.resourceApplicationForm.backupRetentionDays,
            "geoRedundantBackup": this.resourceApplicationForm.geoRedundantBackup,
            "storageAutoGrow": this.resourceApplicationForm.storageAutoGrow
          }
        } else if (this.resourceApplicationForm.databaseType == 7) {
          // Azure 托管数据库&&数据库类型为"Azure Redis 服务器"
          submitLifecycleResourceApplicationDTO.lifecycleResourceAzureRedisDTO = {
            "accountId": this.azureResourceApplicationBasicInfoForm.accountId,
            "location": this.azureResourceApplicationBasicInfoForm.region,
            "resourceGroup": this.azureResourceApplicationBasicInfoForm.resourceGroup,

            "redisName": this.resourceApplicationForm.dnsName,
            "pricingTier": this.resourceApplicationForm.pricingLayer,
            "enableNonSslPort": this.resourceApplicationForm.enableNonSslPort
          }
        }
        this.$api.azurePrice.queryAzureDatabasePrice(submitLifecycleResourceApplicationDTO)
          .then(res => {
            this.resourceApplicationForm.cost = res.data
            this.$emit('success', this.resourceApplicationForm.cost);
          })
      },
      // 切换数据库类型
      changeDatabaseType: function () {
        this.listAzureRedisPricingTierDTO();
        this.queryAzureDatabasePrice();
      },
      // 切换服务器类型
      changeServerType: function () {
        this.resourceApplicationForm.skuCapacity = 1;
        this.resourceApplicationForm.storage = 5;
        this.resourceApplicationForm.backupRetentionDays = 7;
        this.queryAzureDatabasePrice();
      },
      showAll: function () {
        //查询定价层
        this.listAzureRedisPricingTierDTO();
      },
      //查询定价层
      listAzureRedisPricingTierDTO: function () {
        this.$api.lifecycleResourceApplication.listAzureRedisPricingTierDTO({})
          .then(res => {
            if (res.data) {
              this.pricingLayerList = res.data;
              this.resourceApplicationForm.pricingLayer = this.pricingLayerList[0].name;
            }

          })
      }
    }
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/azure/managed_database/AzureManagedDatabase.vue